import { render } from "./Chapter4.vue?vue&type=template&id=46766dc4&scoped=true"
import script from "./Chapter4.vue?vue&type=script&lang=js"
export * from "./Chapter4.vue?vue&type=script&lang=js"

import "./Chapter4.vue?vue&type=style&index=0&id=46766dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46766dc4"]])

export default __exports__